import { ClinicInsights } from '../../api';
import { formatSecondsString } from '../../util/date';

export interface ComparisonMetricOption {
  label: string;
  editLabel?: string;
  value: keyof ClinicInsights;
  targetValueFormatter?: (value: number) => number;
  labelFormatter?: (value: number) => string;
  tickFormatter?: (value: number) => string;
  targetable?: boolean;
}

export const comparisonMetricOptions = [
  { label: 'Total sessions', value: 'totalSessions', targetable: false },
  {
    label: 'Total active patients',
    value: 'activePatientCount',
    targetable: true
  },
  { label: 'Total reps', value: 'totalReps', targetable: false },
  {
    label: 'Total time on task',
    editLabel: 'Total time on task (minutes)',
    value: 'totalTimeTaken',
    targetValueFormatter: (value: number) => value * 60,
    labelFormatter: formatSecondsString,
    tickFormatter: formatSecondsString,
    targetable: false
  },
  { label: 'Avg reps per patient', value: 'avgTotalRepsPerPatient', targetable: true },
  { label: 'Avg reps per session', value: 'avgRepsPerSession', targetable: true },
  {
    label: 'Avg time on task per patient',
    editLabel: 'Avg time on task per patient (minutes)',
    value: 'avgTimeTakenPerPatient',
    targetValueFormatter: (value: number) => value * 60,
    labelFormatter: formatSecondsString,
    tickFormatter: formatSecondsString,
    targetable: true
  },
  {
    label: 'Avg time on task per session',
    editLabel: 'Avg time on task per session (minutes)',
    value: 'avgTimeTakenPerSession',
    targetValueFormatter: (value: number) => value * 60,
    labelFormatter: formatSecondsString,
    tickFormatter: formatSecondsString,
    targetable: true
  }
];
